import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { environment } from 'src/environments/environment';
import { GameRecordForm, PointOfInterestForm } from '../model/form';
import { PointOfInterest } from 'diwimamodelweb/lib';
import { UntypedFormControl } from '@angular/forms';
import { GeoPoint } from 'firebase/firestore';

@Component({
  selector: 'app-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.css']
})
export class LocationPickerComponent implements OnInit {

  @Input() data: PointOfInterestForm|GameRecordForm|any
  // input for what... 
  @Input() fieldName: string
  @Output() submit = new EventEmitter<void>()


  mapStyleOutdors = environment.mapBoxStyleStreets
  mapStyleSatellite = environment.mapBoxStyleOutdoors
  map: mapboxgl.Map
  _browserLanguage = navigator.language
  zoomHeight = 13.5

  showDropdownPoi = false
  dropdownPoi: PointOfInterest[]
  poi = new UntypedFormControl()

  originalCenter: any|undefined

  marker: mapboxgl.Marker

  constructor() { }

  ngOnInit(): void {
    this.initializeMap()
    this.map.on('load', () => {
      this._onMapLoad()
    })
    this.map.on('click', (e) => {
      if (this.map && !this.marker) {
        this.createMarker(e.lngLat)
      }
    })

    this.poi.valueChanges.subscribe((poi) => {
      // check if placeOfKilling empty if yes also set place of killing loc
      // set
      if (poi) {
        if (!poi.locationCoordinates) return
        this.map?.flyTo({
          center: new mapboxgl.LngLat(poi.locationCoordinates.longitude, poi.locationCoordinates.latitude)
        })
        this.createMarker(
          new mapboxgl.LngLat(poi.locationCoordinates.longitude, poi.locationCoordinates.latitude)
        )
      } else {

      }
    })
    
  }

  onMapStyleSelectChange(event) {
    // this.subPOI.unsubscribe()
    // this.subDistricts.unsubscribe()
    let layerId = event.value
    this.map.setStyle(
      `${layerId}`
    )
    this.map.on('style.load', () => {
      this._onMapLoad()
    })
  }

  get disabled() {
    return (!this.originalCenter && !this.marker) || (this.originalCenter?.toString() == this.marker?.getLngLat().toString())
  }

  initializeMap() {
    switch(this.data.className) {
      case(PointOfInterestForm.className): {
        if (this.data.data[this.fieldName]) {
          // location already picked... 
          let center = undefined
          const loc = this.data.data[this.fieldName]
          if (loc) {
            center = new mapboxgl.LngLat(loc.longitude, loc.latitude)
          }
          this.createMap(center)
        } else {
          // fly to district bounds?
          this.createMap(undefined)
          if (this.data.data?.huntingDistrictId) {

          }
        }
        break
      }
      case(GameRecordForm.className): {
        if (this.fieldName == 'hunterLocation') {
          this.showDropdownPoi = true
          this.dropdownPoi = this.data.geoObjects ? this.data.geoObjects : []
          if (this.data.data?.hunterLocation && this.data.data?.hunterLocation?.id) {
            const poi = this.dropdownPoi?.find(el => el.identifier == this.data.data?.hunterLocation?.id)
            this.poi.setValue(poi, {emitEvent: false})
          }
        }
        if (this.data.data[this.fieldName]?.location) {
          // location is present add marker and show on map
          let center = undefined
          const loc = this.data.data[this.fieldName].location
          center = new mapboxgl.LngLat(loc.longitude, loc.latitude)
          this.createMap(center)
        } else {
          // zoom to huntingdistrict?
          if (this.data.data.huntingDistrictId) {
            this.createMap(undefined)
          }
        }
        break
      }
    }
  }

  resetPoi() {
    this.poi.reset()
    this.marker.remove()
    this.marker = undefined
  }

  createMap(center?: mapboxgl.LngLat) {
    this.originalCenter = center
    this.map = new mapboxgl.Map(
      {
        container: 'info_map',
        style: `${this.mapStyleOutdors}`,
        zoom: center ? this.zoomHeight : 5.0, 
        center: center ? center : [10.369743, 51.081317],
      }
    )
    if (center) {
      this.createMarker(center)
    }
  }

  createMarker(lngLat: mapboxgl.LngLat) {
    this.marker?.remove()
    this.marker = new mapboxgl.Marker({
      color: "#FFB300",
      draggable: true
    }).setLngLat(lngLat)
      .addTo(this.map)
    this.marker.on('dragend', () => {
      if(this.poi.value) this.poi.reset()
    });
  }

  _onMapLoad() {
    this.map.resize()
  }

  onSave() {
    const location = this.marker?.getLngLat()
    if (!this.data.data[this.fieldName]) this.data.data[this.fieldName] = {}
    if (this.data.className == GameRecordForm.className) {
      if (location) {
        this.data.data[this.fieldName].location = new GeoPoint(location.lat, location.lng)
        if (this.fieldName == 'hunterLocation') {
          const poi = this.poi.value
          if (poi) {
            if (!this.data.data?.hunterLocation) this.data.data.hunterLocation = {}
            Object.assign(this.data.data.hunterLocation, {location: poi.locationCoordinates, id: poi.identifier, name: poi.shortName})
            if (!this.data.data?.placeOfKilling || !this.data.data?.placeOfKilling.location) {
              this.data.data.placeOfKilling = {}
              Object.assign(this.data.data.placeOfKilling, {location: poi.locationCoordinates})
            }
          }
        } 
      } else {
        this.data.data[this.fieldName] = { id: undefined, name: undefined, location: undefined}
      }
    } else {
      if (location) {
        this.data.data[this.fieldName] = new GeoPoint(location.lat, location.lng)
      } else {
        this.data.data[this.fieldName] = {location: undefined}
      }
    }
    
    this.submit.emit()
  }

}
